import { Theme, useMediaQuery } from "@mui/material";
import { Fragment, useCallback } from "react";
import { TextField, DatagridConfigurable, List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput, BooleanInput, BooleanField } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { laboratoryExporter } from "../../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_LABORATORY_C" />
        <SortButton fields={['name']} />
        <FilterButton />
        <SacopExportButton exporter={laboratoryExporter} />
    </TopToolbar>
);

const laboratoryFilters = [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput source="active" />,
    <TextInput source="name" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );

    return (
        <Fragment>
            {(!isXSmall ? (
                <MobileGrid  {...listContext} />
            ) : (
                <DatagridConfigurable rowClick="edit" >
                    <TextField source="name" />
                    <BooleanField source="active" />
                </DatagridConfigurable>)
            )
            }
        </Fragment>
    );
}

const LaboratoryList = () => {
    const getResourceLabel = useGetResourceLabel();
    return (<List
        filterDefaultValues={ { active: true }}
        sort={{ field: 'name', order: 'DESC' }}
        perPage={25}
        filters={laboratoryFilters}
        actions={<ListActions />}
        exporter={laboratoryExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default LaboratoryList;
